import { DirectorySort } from "../../../common/constants/counterparty";

export interface DirectoryFilters {
    search?: string;
    year?: number;
    entityIds?: number[];
}

export function isRevenueSort(sort: DirectorySort) {
    return (
        sort === DirectorySort.REVENUE_ASC ||
        sort === DirectorySort.REVENUE_DESC
    );
}

export function isSpendSort(sort: DirectorySort) {
    return (
        sort === DirectorySort.SPEND_ASC || sort === DirectorySort.SPEND_DESC
    );
}
